import { Serializable } from "../core";
import { Product, Transaction } from "./index";
import { ProductAttribute } from "./product-attribute";

export type OrderState = "PENDING" | "PAID" | "POSTED" | "DELIVERED";

export class OrderItem implements Serializable<OrderItem> {
  id!: string;
  product!: Product;
  attribute!: ProductAttribute;
  count!: number;

  deserialize(json: any): OrderItem {
    this.id = json.id.toString();
    this.product = new Product().deserialize(json.product);
    this.attribute = new ProductAttribute().deserialize(json.attribute);
    this.count = json.count;
    return this;
  }
}

export class Order implements Serializable<Order> {
  id!: string;
  orderId!: string;
  state!: OrderState;
  addressString!: string;
  items!: OrderItem[];
  transaction!: Transaction;
  date!: Date;
  postalTrackingCode!: string;

  deserialize(json: any): Order {
    this.id = json.id;
    this.orderId = json.order_id;
    this.state = json.state as OrderState;
    this.addressString = json.address_string;
    this.items = json.items.map((json: any) =>
      new OrderItem().deserialize(json)
    );
    if (json.transaction !== null)
      this.transaction = new Transaction().deserialize(json.transaction);
    this.date = new Date(json.date);
    this.postalTrackingCode = json.postal_tracking_code;
    return this;
  }
}
